<template>
    <section>
        <form id="rest-select-form" @submit.prevent="submitForm">
            <input ref="pass0" type="password" maxlength="4" v-model="accessCode" />
            <p>Enter your restaurant access code</p>
            <input type="submit" value="GO">
        </form>   

    </section>
</template>

<script>
	export default {
        name: 'AccessForm',
        data () {
            return {
                accessCode: null
            }
        },
        methods: {
            submitForm () {
                this.$store.dispatch('alerts/setRestId', { restId: this.accessCode })
                this.accessCode = null
            }
        }
	}

</script>

<style lang="scss" scoped>
	@import '@/scss/imports.scss';

    form#rest-select-form {
        text-align: center; 
        p  {
            margin: 15px;
        }
        input {
            margin: 24px;
        }
        input[type="password"] {
            border: solid black 1px;
            width: 170px; height: 64px;
            font-size: 54px;
            text-align: center;
            letter-spacing: 11px;
        }
        input[type="submit"] {
            display: block;
            width: 144px;
            height: 56px;
            border-radius: 4px;
            background-color: $bluegreen;
            color: white;
            text-align: center;
            margin: 0 auto;
            
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ui/restaurant-select/AccessForm.vue